import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20b4b310")

_pushScopeId("data-v-20b4b310")
const _hoisted_1 = { class: "tabContainer" }
const _hoisted_2 = { class: "label_container" }
const _hoisted_3 = { class: "d-flex mb_10" }
const _hoisted_4 = {
  key: 0,
  class: "inputContainer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.labelKey)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              localizedKey: _ctx.labelKey,
              text: _ctx.labelValue
            }, null, 8, ["localizedKey", "text"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (langTab, i) => {
          return (_openBlock(), _createBlock("div", {
            class: ["tab", _ctx.selectedLocale == langTab ? 'active' : ''],
            key: i,
            onClick: ($event: any) => (_ctx.setInputLocale(langTab))
          }, _toDisplayString(langTab), 11, ["onClick"]))
        }), 128))
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", { locale: _ctx.selectedLocale }, () => [
            _withDirectives(_createVNode("textarea", {
              class: "w-100",
              type: _ctx.type,
              placeholder: _ctx.placeholder,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedInput = $event)),
              tabindex: _ctx.tabIndex,
              rows: "10"
            }, "\r\n                ", 8, ["type", "placeholder", "tabindex"]), [
              [_vModelText, _ctx.selectedInput]
            ])
          ], true)
        ]))
      : _createCommentVNode("", true)
  ]))
})